// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".component-card[data-v-245e79a2] {\n  position: relative;\n  background: #fff;\n  box-shadow: 0px 12px 24px 4px rgba(0, 0, 0, 0.15), 0px 8px 12px 3px rgba(0, 0, 0, 0.08), 0px 4px 8px 2px rgba(0, 0, 0, 0.08);\n}\n", ""]);
// Exports
module.exports = exports;
